"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InfiniteLoader_1 = require("./InfiniteLoader");
exports.default = InfiniteLoader_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/InfiniteLoader/index.js
// module id = 307
// module chunks = 8